// extracted by mini-css-extract-plugin
export default {"unDrag":"unDrag--TxfyM","unSelect":"unSelect--OfoM9","dynamic":"dynamic--j21ny"};